import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations = {
  'en-US': {
    'active offers': "Active offers",
    'all':'All',
    'and': "and",
    'application start date': 'Application start date',
    'application deadline': 'Application deadline',
    'book table': 'Book a table',
    'by appointment': 'By appointment',
    'choose date': 'Choose date',
    'close': 'Close',
    'closed': 'Closed',
    'close menu': 'Close menu',
    'day': 'Day',
    'enter category': "By category",
    'enter floor': 'By floor',
    'events':'News',
    'exceptional opening hours': "Exceptional opening hours",


    'feedback.required_fields_marked_by_star': 'Required fields',
    'feedback.target': 'Target',
    'feedback.choose_shop' : 'Choose a shop',
    'feedback.type_of_feedback' : 'Type of feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Name',
    'feedback.email' : 'Email',
    'feedback.target.general': 'General feedback',
    'feedback.target.store': 'Feedback to a specific company',
    'feedback.type.thanks': 'Thanks',
    'feedback.type.suggestion': 'Suggestion',
    'feedback.type.complaint': 'Complaint',
    'feedback.type.other': 'Other',
    'feedback.rsvp' : 'I would like to receive a reply',
    'feedback.privacy_statement' : 'Privacy policy',
    'feedback.thank_you' : 'Thank you for your feedback',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
    'feedback.error.field_required' : 'Field is required',
    'feedback.error.invalid_email_address' : 'Invalid email address',
    'feedback.error.please_choose_a_store' : 'Please choose a store',

    'follow us on social media': "Follow us from social media",
    'floor map': 'Floor map',
    'gift card accepted': 'We welcome centre gift cards',
    'go to store': 'Go to store',
    'language': 'English',
    'lunch time': 'Lunch time',
    'lunch today': "Lunch today", 
    'map': 'Map',
    'more about us': 'More about us',
    'navigation': 'Navigation',
    'open menu': "Open menu (pdf)",
    'opening hours': 'Opening hours',
    'order food online': 'Order food online',
    'order food from us':'From us you can also order food with home delivery!',
    'position': 'Position',
    'post': 'Post',
    'search': 'Search',
    'send e-mail': 'Send e-mail',
    'similar restaurants': 'Similar restaurants',
    'similar stores': 'Similar stores',
    'show less': 'Show less',
    'show more': 'Show more',
    'store.status.BY_APPOINTMENT': 'By appointment',
    'store.status.CLOSED': 'Closed',
    'store.status.OPEN': 'Open',
    'store.status.TEMPORARY_CLOSED': 'Temporarily closed',
    'student offers': 'Student offers',
    'your search did not match any results':'Your search did not match any results',
    'today': 'Today',
    'no content': 'No content currently available',
    'map-instruction-text': 'Open the map to interact',
    'map-instruction-button-text': 'Find a route or shop location',
    
    'choose-store': 'Choose store',
    'service-locations.show-on-map': 'Show on map',
    'service-locations.train': 'Train',
    'service-locations.elevator': 'Elevator',
    'service-locations.toilet': 'Toilet',
    'service-locations.accessible_wc': 'Accessible WC',
    'service-locations.stairs': 'Stair',
    'service-locations.escalator': 'Escalator',
    'service-locations.nursery_room': 'Nursery room',
    'service-locations.atm': 'ATM',

    'common.back': 'Back',
    'common.benefits': 'Benefits',
    'common.next': 'Next',
    'common.ok': 'OK',
    'common.previous': 'Previous',
    'common.readMore': 'Read more',
    'common.readMoreFacebook': 'Read more',
    'common.privacyPolicy': 'Privacy policy',
    'common.downloadApp': 'Download app',
    'common.buyGiftCards': 'Buy gift cards',
    'common.orderNewsLetter': 'Order newsletter',
    'common.seeOpeningHours': 'Opening hours',
    'common.howToArrive': 'How to arrive',
    'common.floormap': 'Floormap',
    'common.storesOpenedAtLeast': 'Stores open today at least',
    'common.whatsNew': 'What\'s new',
    'common.viewMore': 'View more',
    'common.viewLess': 'View less',
    'common.viewMoreNews': 'View more news',
    'common.tomorrow': 'Tomorrow',
    'common.dateSelector': 'Select date',
    'common.coming': 'Coming',
    'common.showAll': 'Show all',
    'cookie.policy': 'Our site uses cookies to guarantee the best user experience. By continuing the use of the site you accept the use of cookies.',
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.valid': 'Valid',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'search.noResults': 'No results',
    'search.placeholder': 'Search',
  },
  'fi-FI': {
    'active offers': "Ajankohtaiset tarjoukset",
    'all': 'Kaikki',
    'and': "ja",
    'application deadline': 'Hakuaika päättyy',
    'book table': 'Varaa pöytä',
    'by appointment': 'Sopimuksen mukaan',
    'choose date': 'Valitse päivä',
    'close': 'Sulje',
    'closed': 'Suljettu',
    'close menu': 'Sulje valikko',
    'day': 'Päivä',
    'enter category': "Toimialoittain",
    'enter floor': 'Kerroksittain',
    'events':'Ajankohtaiset',
    'exceptional opening hours': "Poikkeusaukioloajat",

    'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
    'feedback.target': 'Kohde',
    'feedback.choose_shop' : 'Valitse liike',
    'feedback.type_of_feedback' : 'Palautteen tyyppi',
    'feedback.message': 'Palaute',
    'feedback.name' : 'Nimesi',
    'feedback.email' : 'Sähköpostiosoitteesi',
    'feedback.target.general': 'Haluan antaa yleistä palautetta',
    'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
    'feedback.type.thanks': 'Kiitos',
    'feedback.type.suggestion': 'Ehdotus',
    'feedback.type.complaint': 'Moite',
    'feedback.type.other': 'Muu',
    'feedback.rsvp' : 'Haluan, että minulle vastataan',
    'feedback.privacy_statement' : 'Rekisteriseloste',
    'feedback.thank_you' : 'Kiitos palautteesta!',
    'feedback.send': 'Lähetä',
    'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
    'feedback.error.field_required' : 'Kenttä on pakollinen',
    'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
    'feedback.error.please_choose_a_store' : 'Tee valinta',

    'follow us on social media': "Seuraa meitä",
    'floor map': 'Pohjakartta',
    'gift card accepted': 'Meillä voit maksaa kauppakeskuksen lahjakortilla',
    'go to store': 'Liikkeen sivulle',
    'language': 'Suomi',
    'lunch time': 'Lounasaika',
    'lunch today': "Tänään lounaalla", 
    'map': 'Pohjakartta',
    'more about us': 'Lisätietoja keskuksesta',
    'navigation': 'Valikko',
    'open menu': "Avaa ruokalista (pdf)",
    'opening hours': 'Aukioloajat',
    'order food online': 'Tilaa ruokaa netistä',
    'order food from us': 'Meiltä voit tilata myös kotiinkuljetuksella!',
    'position': 'Työpaikka',
    'post': 'Työpaikka',
    'search': 'Hae',
    'send e-mail': 'Lähetä sähköpostia',
    'similar restaurants': 'Lisää ravintoloita',
    'similar stores': 'Lisää liikkeitä',
    'show less': 'Näytä vähemmän',
    'show more': 'Näytä lisää',
    'store.status.BY_APPOINTMENT': 'Sopimuksen mukaan',
    'store.status.CLOSED': 'Suljettu',
    'store.status.OPEN': 'Avoinna',
    'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
    'student offers': 'Opiskelijatarjoukset',
    'today': 'Tänään',
    'your search did not match any results': 'Haku ei vastannut yhtään osumaa',
    'no content': 'Ei näytettävää sisältöä juuri nyt',
    'map-instruction-text': 'Avaa interaktiivinen kartta',
    'map-instruction-button-text': 'Etsi reitti tai liike',

    'choose-store': 'Valitse kauppa',
    'service-locations.show-on-map': 'Näytä kartalla',
    'service-locations.train': 'Juna',
    'service-locations.elevator': 'Hissi',
    'service-locations.toilet': 'WC',
    'service-locations.accessible_wc': 'Inva WC',
    'service-locations.stairs': 'Rappu',
    'service-locations.escalator': 'Liukuportaat',
    'service-locations.nursery_room': 'Lastenhuone',
    'service-locations.atm': 'Otto',

    'common.back': 'Takaisin',
    'common.benefits': 'Tarjoukset',
    'common.next': 'Seuraava',
    'common.ok': 'OK',
    'common.previous': 'Edellinen',
    'common.readMore': 'Lue lisää',
    'common.readMoreFacebook': 'Lue lisää Facebookissa',
    'common.privacyPolicy': 'Rekisteriseloste',
    'common.downloadApp': 'Lataa sovellus',
    'common.buyGiftCards': 'Osta lahjakortteja',
    'common.orderNewsLetter': 'Tilaa uutiskirje',
    'common.seeOpeningHours': 'Olemme avoinna',
    'common.howToArrive': 'Saapuminen',
    'common.floormap': 'Pohjakartta',
    'common.storesOpenedAtLeast': 'Liikkeet auki tänään vähintään',
    'common.whatsNew': 'Tapahtumat',
    'common.viewMore': 'Katso lisää',
    'common.viewLess': 'Katso vähemmän',
    'common.viewMoreNews': 'Lisää tapahtumia',
    'common.tomorrow': 'Huomenna',
    'common.dateSelector': 'Valitse päivä',
    'common.coming': 'Tulossa',
    'common.showAll': 'Koko ohjelma',
    'cookie.policy': 'Sivustomme käyttää evästeitä parhaan käyttökokemuksen takaamiseksi. Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön.',
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.noContent':'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox':'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.valid': 'Voimassa',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'search.noResults': 'Ei tuloksia',
    'search.placeholder': 'Hae',
  },
  'sv-SE': {
    'active offers': "Aktuella erbjudanden",
    'all': 'Alla',
    'and': "och",
    'application deadline': 'Ansökningstiden',
    'book table': 'Boka bord',
    'by appointment': 'Enl. Överenskommelse',
    'choose date': 'Välj datum',
    'close': 'Stäng',
    'closed': 'Stängt',
    'close menu': 'Stäng menyn',
    'day': 'Dag',
    'enter category': "Enligt kategori",
    'enter floor': 'Enligt plan',
    'events':'Nyheter',
    'exceptional opening hours': "Avvikande öppettider",

    'feedback.required_fields_marked_by_star': 'Obligatoriskt fält',
    'feedback.target': 'Mål',
    'feedback.choose_shop' : 'Velg butikk',
    'feedback.type_of_feedback' : 'Typ av feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Namn',
    'feedback.email' : 'E-post',
    'feedback.thank_you' : 'Tack för din feedback!',
    'feedback.target.general': 'Allmän feedback',
    'feedback.target.store': 'Feedback till ett specifikt företag',
    'feedback.type.thanks': 'Tack',
    'feedback.type.suggestion': 'Förslag',
    'feedback.type.complaint': 'Klagomål',
    'feedback.type.other': 'Annan',
    'feedback.rsvp' : 'Jag önskar få svar',
    'feedback.privacy_statement' : 'Dataskyddsbeskrivning',
    'feedback.send': 'Sänd',
    'feedback.error.check_all_required_fields': 'Kontrollera att alla obligatoriska fält är ifyllda',
    'feedback.error.field_required' : 'Fältet är obligatoriskt',
    'feedback.error.invalid_email_address' : 'Ogiltig e-postadress',
    'feedback.error.please_choose_a_store' : 'Välj en butik',

    'follow us on social media': "Följ oss i social media",
    'floor map': 'Karta',
    'gift card accepted': 'Vi tar emot centrumets presentkort',
    'go to store': 'Till butiken',
    'language': 'Svenska',
    'lunch time': 'Lunchtid',
    'lunch today': "Lunch idag", 
    'map': 'Karta',
    'more about us': 'Mer om oss',
    'navigation': 'Navigering',
    'open menu': "Öppna menyn (pdf)",
    'opening hours': 'Öppettider',
    'order food online': 'Beställ mat på nätet',
    'order food from us':'Du kan även beställa mat via hemleverans!',
    'position': 'Jobb',
    'post': 'post?',
    'search': 'Sök',
    'send e-mail': 'Skicka e-post',
    'similar restaurants': 'Liknande restauranger',
    'similar stores': 'Liknande butiker',
    'show less': 'Visa mindre',
    'show more': 'Visa fler',
    'store.status.BY_APPOINTMENT': 'Enl. Överenskommelse',
    'store.status.CLOSED': 'Stängt',
    'store.status.OPEN': 'Öpna',
    'store.status.TEMPORARY_CLOSED': 'Tillfälligt stängt',
    'student offers': 'Studenterbjudanden',
    'today':'Idag',
    'your search did not match any results': 'Inga resultat',
    'no content': 'Inget innehåll tillgängligt för tillfället',
    'map-instruction-text': 'Öppna interaktiva kartan',
    'map-instruction-button-text': 'Hitta rutt eller butik',

    'common.back': 'Tillbaka',
    'common.benefits': 'Erbjudanden',
    'common.next': 'Nästa',
    'common.ok': 'OK',
    'common.previous': 'Föregående',
    'common.readMore': 'Läs mer',
    'common.privacyPolicy': 'Sekretesspolicy',
    'common.downloadApp': 'Ladda ner applikation',
    'common.buyGiftCards': 'Köp presentkort',
    'common.orderNewsLetter': 'Beställ nyhetsbrev',
    'common.seeOpeningHours': 'Alla öppettider',
    'common.storesOpeningHours': 'Butikerna öppna åtminstone:',
    'common.storesOpenedAtLeast': 'Butikerna öppna idag åtminstone till',
    'common.whatsNew': 'Aktuellt',
    'common.viewMoreBenefits': 'Se fler förmåner',
    'common.viewMoreNews': 'Se fler tips',
    'common.tomorrow': 'Imorgon',
    'common.dateSelector': 'Välj dag',
    'common.showAll': 'Visa alla',
    'cookie.policy': 'Vår webbplats använder kakor (cookies) för att garantera bästa möjliga användarupplevelse. Om du fortsätter att använda webbplatsen, accepterar du användningen av kakor.',
    'offers.allDays': 'Alla dagar',
    'offers.allCategories': 'Alla kategorier',
    'offers.allOffers': 'Alla erbjudanden',
    'offers.showWishList': 'Visa önskelista',
    'offers.closeOffer': 'Stäng',
    'offers.seeWholeOffer': 'See hela förmånen',
    'offers.noOffers': 'Tyvärr finns det för tillfället inga förmåner',
    'offers.noContent':'Inget innehåll tillgängligt för tillfället',
    'offers.searchBox':'Söka',
    'offers.clearSelection': 'Rensa val',
    'offers.openInfo':'Öppna erbjudandets info',
    'offers.daysLowestPrice': 'Lägsta pris 30 dagar',
    'offers.valid': 'Gäller',
    'offers.store': 'Butiker',
    'offers.offer': 'Erbjudanden',
    'search.noResults': 'Inga resultat',
    'search.placeholder': 'Sök'
  },
  'nb-NO': {
    'active offers': "Aktive tilbud",
    'all':'Alle',
    'and': "og",
    'application start date': 'Annonsen publisert',
    'application deadline': 'Søknadsfrist',
    'book table': 'Reserver et bord',
    'by appointment': 'Etter avtale',
    'choose date': 'Velg dato',
    'close': 'Lukk',
    'closed': 'Stengt',
    'close menu': 'Lukk meny',
    'day': 'Dag',
    'enter category': "Etter kategori",
    'enter floor': 'Etter etasje',
    'events': 'Nyheder',
    'exceptional opening hours': "Avvikende åpningstider",

    'feedback.required_fields_marked_by_star': 'Obligatorisk felt',
    'feedback.target': 'Mål',
    'feedback.choose_shop' : 'Velg butikk',
    'feedback.type_of_feedback' : 'Type tilbakemelding',
    'feedback.message': 'Tilbakemelding',
    'feedback.name' : 'Navn',
    'feedback.email' : 'E-post',
    'feedback.target.general': 'Generell tilbakemelding',
    'feedback.target.store': 'Tilbakemelding til et spesifikt selskap',
    'feedback.type.thanks': 'Takk',
    'feedback.type.suggestion': 'Forslag',
    'feedback.type.complaint': 'Klage',
    'feedback.type.other': 'Annet',
    'feedback.rsvp' : 'Jeg ønsker å motta et svar',
    'feedback.privacy_statement' : 'Personvernerklæring',
    'feedback.thank_you' : 'Takk for din tilbakemelding',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Vennligst sjekk at alle de obligatoriske feltene er fylt ut',
    'feedback.error.field_required' : 'Tilbakemeldingsfelt kreves',
    'feedback.error.invalid_email_address' : 'Ugyldig e-postadresse',
    'feedback.error.please_choose_a_store' : 'Vennligst velg en butikk',

    'follow us on social media': "Følg oss på sosiale medier",
    'floor map': 'Planløsning',
    'gift card accepted': 'Vi tar i mot gavekort fra senteret',
    'go to store': 'Til butikken',
    'language': '???',
    'lunch time': 'Lunsjtid',
    'lunch today': "Lunsj i dag", 
    'map': 'Kart',
    'more about us': 'Om oss',
    'navigation': 'Navigasjon',
    'open menu': 'Se meny',
    'opening hours': 'Åpningstider',
    'order food online': 'Bestill mat online',
    'order food from us':'Fra oss kan du også bestille mat hjem til deg!',
    'position': 'Stilling',
    'post': 'Stilling',
    'search': 'Søk',
    'send e-mail': 'Send e-post',
    'similar restaurants': 'Lignende restauranter',
    'similar stores': 'Lignende butikker',
    'show less': 'Vis mindre',
    'show more': 'Vis mer',
    'store.status.BY_APPOINTMENT': 'Etter avtale',
    'store.status.CLOSED': 'Stengt',
    'store.status.OPEN': '__',
    'store.status.TEMPORARY_CLOSED': 'Midlertidig stengt',
    'student offers': 'Studenttilbud',
    'today':'I dag',
    'your search did not match any results': 'Ingen treff på søket',
    'no content': 'Inget innhold tilgjengelig for øyeblikket',
    'map-instruction-text': 'Åpne det interaktive kartet',
    'map-instruction-button-text': 'Finn rute eller butikk',

    'common.back': 'Tilbake',
    'common.benefits': 'Tilbud',
    'common.ok': 'OK',
    'common.next': 'Neste',
    'common.previous': 'Forrige',
    'common.readMore': 'Les mer',
    'common.privacyPolicy': 'Personvernerklæring',
    'common.downloadApp': 'Last ned app',
    'common.buyGiftCards': 'Kjøp gavekort',
    'common.orderNewsLetter': 'Abonner på nyhetsbrev',
    'common.seeOpeningHours': 'Avvikende åpningstider',
    'common.storesOpenedAtLeast': 'Butikker åpne i dag til minst',
    'common.showMore': 'Vis mer',
    'common.whatsNew': 'Hva er nytt',
    'common.viewMoreBenefits': 'Se flere fordeler',
    'common.viewMoreNews': 'Se flere nyheter',
    'common.tomorrow': 'I morgen',
    'common.dateSelector': 'Velg dato',
    'common.showAll': 'Vis alt',
    'cookie.policy': 'Nettstedet vårt benytter informasjonskapsler for å garantere den beste brukeropplevelsen. Ved å fortsette å benytte nettstedet, godkjenner du bruken av informasjonskapsler.',
    'offers.allDays': 'Alle dager',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle tilbud',
    'offers.showWishList': 'Se ønskeliste',
    'offers.closeOffer': 'Lukk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Dessverre ingen fordeler tilgjengelig for øyeblikket',
    'offers.noContent':'Inget innhold tilgjengelig for øyeblikket',
    'offers.searchBox':'Søk',
    'offers.clearSelection': 'Fjern valg',
    'offers.openInfo':'Les mer',
    'offers.daysLowestPrice': 'Laveste pris siste 30 dager',
    'offers.valid': 'Gyldig',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søk',
  },
  'et-EE': {
    'active offers': "Aktiivsed pakkumised",
    'all':'Kõik',
    'and': "ja",
    'application deadline': 'Taotluste esitamise tähtaeg',
    'book table': 'Broneeri laud',
    'by appointment': 'Kokkuleppel',
    'choose date': 'Vali kuupäev',
    'close': 'Sulge',
    'closed': 'Suletud',
    'close menu': 'Sulge menüü',
    'day': 'Päev',
    'enter category': "Kategooria alusel",
    'enter floor': 'Korruste kaupa',
    'events': 'Uudised ja sündmused',
    'exceptional opening hours': "Erakorraline lahtiolekuaeg",

    'feedback.required_fields_marked_by_star': 'Kohustuslik väli',
    'feedback.target': 'Target',
    'feedback.choose_shop' : 'Vali pood',
    'feedback.type_of_feedback' : 'Tagasiside tüüp',
    'feedback.message': 'Sõnum',
    'feedback.name' : 'Nimi',
    'feedback.email' : 'E-post',
    'feedback.target.general': 'Üldine tagasiside',
    'feedback.target.store': 'Kauplus',
    'feedback.type.thanks': 'Tänan',
    'feedback.type.suggestion': 'Soovitus',
    'feedback.type.complaint': 'Kaebus',
    'feedback.type.other': 'Muu',
    'feedback.rsvp' : 'Soovin saada vastust',
    'feedback.privacy_statement' : 'Privaatsussätted',
    'feedback.thank_you' : 'Täname tagasiside eest!',
    'feedback.send': 'Saada',
    'feedback.error.check_all_required_fields': 'Kontrollige kõiki kohustuslikke välju',
    'feedback.error.field_required' : 'Kohustuslik väli',
    'feedback.error.invalid_email_address' : 'E-posti formaat on vale',
    'feedback.error.please_choose_a_store' : 'Palun vali pood',

    'follow us on social media': "Jälgi meid sotsiaalmeedias",
    'floor map': 'Korruseplaan',
    'gift card accepted': 'Aktsepteerib keskuse kinkekaarte',
    'go to store': 'Mine poodi',
    'language': '???',
    'lunch time': 'Lõunapaus',
    'lunch today': "Tänane lõuna", 
    'map': 'Kaart',
    'more about us': 'Meist lähemalt',
    'navigation': 'Navigeerimine',
    'open menu': 'Ava menüü (pdf)',
    'opening hours': 'Lahtiolekuajad',
    'order food online': 'Telli toit internetist',
    'order food from us':'Meilt saab toitu ka koju tellida!',
    'position': 'Positsiooni',
    'post': 'Postitus',
    'search': 'Otsi',
    'send e-mail': 'Saada e-post',
    'similar restaurants': 'Sarnased restoranid',
    'similar stores': 'Sarnased kauplused',
    'show less': 'Näita vähem',
    'show more': 'Näita rohkem',
    'store.status.BY_APPOINTMENT': 'Kokkuleppel',
    'store.status.CLOSED': 'Suletud',
    'store.status.OPEN': '__',
    'store.status.TEMPORARY_CLOSED': 'Ajutiselt suletud',
    'student offers': 'Õpilaste pakkumised',
    'today':'Täna',
    'your search did not match any results': 'Teie otsing ei andnud tulemusi',
    'no content': 'Hetkel sisu puudub',
    'map-instruction-text': 'Avage interaktiivne kaart',
    'map-instruction-button-text': 'Leidke marsruut või pood',

    'common.back': 'Tagasi',
    'common.next': 'Järgmine',
    'common.ok': 'OK',
    'common.previous': 'Eelmine',
    'common.readMore': 'Loe lisaks',
    'common.privacyPolicy': 'Privaatsussätted',
    'common.downloadApp': 'Laadi rakendus alla',
    'common.buyGiftCards': 'Osta kinkekaarte',
    'common.orderNewsLetter': 'Telli uudiskiri',
    'common.seeOpeningHours': 'Vaata lahtiolekuaegu',
    'common.storesOpenedAtLeast': 'Kauplused avatud täna vähemalt kuni',
    'common.showMore': 'Näita rohkem',
    'common.viewMoreBenefits': 'Vaata veel soodustusi',
    'common.viewMoreNews': 'Vaata veel uudiseid',
    'common.tomorrow': 'Homme',
    'common.dateSelector': 'Vali kuupäev',
    'common.benefits': 'Pakkumised',
    'common.whatsNew': 'Uudised',
    'common.showAll': 'Kogu programm',
    'cookie.policy': 'Meie veebilehekülg kasutab parima kasutuskogemuse tagamiseks küpsiseid. Veebilehel sirvimist jätkates oled küpsiste kasutamisega nõustunud.',
    'offers.allDays': 'Kõik päevad',
    'offers.allCategories': 'Kõik kategooriad',
    'offers.allOffers': 'Kõik pakkumised',
    'offers.showWishList': 'Vaata soovinimekirja',
    'offers.closeOffer': 'Sulge',
    'offers.seeWholeOffer': 'Vaata kogu soodustust',
    'offers.noOffers': 'Kahjuks hetkel soodustusi ei ole',
    'offers.noContent':'Hetkel sisu puudub',
    'offers.searchBox':'Otsi',
    'offers.clearSelection': 'Tühjenda valik',
    'offers.openInfo':'Ava pakkumise kirjeldus',
    'offers.daysLowestPrice': 'Viimase 30 päeva madalaim hind',
    'offers.valid': 'Kehtib kuni',
    'offers.store': 'Kauplused',
    'offers.offer': 'Pakkumised',
    'search.noResults': 'Vasted puuduvad',
    'search.placeholder': 'Otsi'
  },
  'da-DK': {
    'active offers': "Aktive tilbud",
    'all':'Alle',
    'and': "og",
    'application start date': 'Ansøgningens startdato',
    'application deadline': 'Ansøgningsfrist',
    'book table': 'Reservere et bord',
    'by appointment': 'Efter aftale',
    'choose date': 'Vælg dato',
    'close': 'Lukke',
    'closed': 'Lukket',
    'close menu': 'Luk menuen',
    'day': 'dag',
    'enter category': "Efter kategori",
    'enter floor': 'Efter etage',
    'events': "Nyheder",
    'exceptional opening hours': "Ekstraordinære åbningstider",

    'feedback.required_fields_marked_by_star': "Obligatorisk felt",
    'feedback.target': 'Mål',
    'feedback.choose_shop' : 'Vælg en butik',
    'feedback.type_of_feedback' : 'Feedbacktype',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Navn',
    'feedback.email' : 'E-mail',
    'feedback.target.general': 'Generel feedback',
    'feedback.target.store': 'Feedback til et bestemt firma',
    'feedback.type.thanks': 'Tak',
    'feedback.type.suggestion': 'Forslag',
    'feedback.type.complaint': 'Klage',
    'feedback.type.other': 'Andet',
    'feedback.rsvp' : 'Jeg vil gerne modtage et svar',
    'feedback.privacy_statement' : 'Privatlivspolitik',
    'feedback.thank_you' : 'Tak for din feedback',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Tjek venligst, at alle obligatoriske felter er udfyldt',
    'feedback.error.field_required' : 'Feltet er påkrævet',
    'feedback.error.invalid_email_address' : 'Ugyldig e-mailadresse',
    'feedback.error.please_choose_a_store' : 'Vælg venligst en butik',

    'follow us on social media': "Følg os på sociale medier",
    'floor map': 'Grundplan',
    'gift card accepted': 'Vi modtager gerne centergavekort',
    'go to store': 'Gå i butikken',
    'language': '???',
    'lunch time': 'Frokost tid',
    'lunch today': "Frokost i dag", 
    'map': 'Kort',
    'more about us': 'Mere om os',
    'navigation': 'Navigation',
    'open menu': 'Åbn menuen',
    'opening hours': 'Åbningstider',
    'order food online': 'Bestil mad online',
    'order food from us':'Hos os kan du også bestille mad med hjemlevering!',
    'position': 'Position',
    'post': 'Stolpe',
    'search': 'Søg',
    'send e-mail': 'Send e-mail',
    'similar restaurants': 'Lignende restauranter',
    'similar stores': 'Lignende butikker',
    'show less': 'Vis mindre',
    'show more': 'Vis mere',
    'store.status.BY_APPOINTMENT': 'Efter aftale',
    'store.status.CLOSED': 'Lukket',
    'store.status.OPEN': 'Åben',
    'store.status.TEMPORARY_CLOSED': 'Midlertidigt lukket',
    'student offers': 'Elevtilbud',
    'your search did not match any results':'Din søgning matchede ingen resultater',
    'today':'I dag',
    'no content': 'Intet indhold tilgængeligt i øjeblikket',
    'map-instruction-text': 'Åbn det interaktive kort',
    'map-instruction-button-text': 'Find rute eller butik',
    'choose-store': 'Vælg butik',
    'service-locations.accessible_wc': 'Tilgængeligt toilet',
    'service-locations.show-on-map': 'Vis på kort',
    'service-locations.train': 'Tog',
    'service-locations.elevator': 'Elevator',
    'service-locations.toilet': 'Toilet',

    'common.back': 'Tilbage',
    'common.benefits': 'Tilbud',
    'common.next': 'Næste',
    'common.ok': 'OK',
    'common.previous': 'Forrige',
    'common.readMore': 'Læs mere',
    'common.privacyPolicy': 'Privatlivspolitik',
    'common.downloadApp': 'Download app',
    'common.buyGiftCards': 'Køb gavekort',
    'common.orderNewsLetter': 'Bestil nyhedsbrev',
    'common.seeOpeningHours': 'Se åbningstider',
    'common.storesOpenedAtLeast': 'Åbne butikker i dag, min.',
    'common.showMore': 'Vis mere',
    'common.whatsNew': 'Nyheder',
    'common.viewMoreBenefits': 'Se flere fordele',
    'common.viewMoreNews': 'Se flere nyheder',
    'common.tomorrow': 'I morgen',
    'common.dateSelector': 'Vælg dato',
    'common.showAll': 'Vis alt',
    'cookie.policy': 'Vores hjemmeside bruger cookies for at skabe en bedre brugeroplevelse. Ved fortsat brug af siden accepterer du brug af cookies.',
    'offers.allDays': 'Alle dage',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle fordele',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Luk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Der er desværre ingen fordele i øjeblikket',
    'offers.noContent':'Intet indhold tilgængeligt i øjeblikket',
    'offers.searchBox':'Søge',
    'offers.clearSelection': 'Ryd markering',
    'offers.openInfo':'Åbn tilbudsbeskrivelse',
    'offers.daysLowestPrice': 'Laveste pris de sidste 30 dage',
    'offers.valid': 'Gyldig',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søg'
  },
  'ru-RU': {
    'active offers': "активные предложения",
    'all':'все',
    'application deadline': 'крайний срок подачи заявок',
    'book table': 'Заказать столик',
    'by appointment': 'по предварительной записи',
    'choose date': 'Выберите день',
    'close': 'Закрыть',
    'closed': 'Закрыто',
    'close menu': 'Закрыть меню',
    'day': 'День',
    'enter category': "к категория",
    'enter floor': 'по этажам',
    'events': 'Новости',
    'exceptional opening hours': "В праздничные дни и выходные",

    'feedback.required_fields_marked_by_star': 'Oбязательно к заполнению',
    'feedback.target': 'цель',
    'feedback.choose_shop' : 'выберите магазин',
    'feedback.type_of_feedback' : 'Категория отзыва',
    'feedback.message': 'сообщение',
    'feedback.name' : 'Имя',
    'feedback.email' : 'Электронный адрес',
    'feedback.target.general': 'Üldine tagasiside',
    'feedback.target.store': 'Магазин',
    'feedback.type.thanks': 'Благодарность',
    'feedback.type.suggestion': 'Предложение',
    'feedback.type.complaint': 'Жалоба',
    'feedback.type.other': 'Другое',
    'feedback.rsvp' : 'Мне хотелось бы получить ответ',
    'feedback.privacy_statement' : 'Политика конфиденциальности',
    'feedback.thank_you' : 'Благодарим вас за отзыв!',
    'feedback.send': 'Отправить',
    'feedback.error.check_all_required_fields': 'проверить все обязательные поля',
    'feedback.error.field_required' : 'Oбязательно к заполнению',
    'feedback.error.invalid_email_address' : 'Адрес электронной почты недействителен',
    'feedback.error.please_choose_a_store' : 'Пожалуйста выберите магазин',

    'follow us on social media': "следите за нами в социальных сетях",
    'floor map': 'Карта',
    'gift card accepted': 'подарочная карта принимается',
    'go to store': 'иди в магазин',
    'language': '???',
    'lunch time': 'Обед подают',
    'lunch today': "Обеденное меню на сегодня", 
    'map': 'Карта',
    'more about us': 'больше о нас',
    'navigation': 'навигация',
    'open menu': 'Открыть меню (pdf)',
    'opening hours': 'Часы работы',
    'order food online': 'Заказать еду по интернету',
    'order food from us':'У нас вы можете заказать еду также с доставкой на дом!',
    'position': 'позиция',
    'post': 'почта',
    'search': 'поиск',
    'send e-mail': 'Отправить электронное письмо',
    'similar restaurants': 'похожие рестораны',
    'similar stores': 'похожие магазины',
    'show less': 'показывай меньше',
    'show more': 'Показать больше',
    'store.status.BY_APPOINTMENT': 'по предварительной записи',
    'store.status.CLOSED': 'Закрыто',
    'store.status.OPEN': '__',
    'store.status.TEMPORARY_CLOSED': 'Temporarily closed',
    'student offers': 'студенческие предложения',
    'today':'Сегодня',
    'your search did not match any results': 'Ваш запрос не дал результатов',
    'no content': 'Нет информации по выбранной теме',
    'map-instruction-text': 'Expand the map full screen to make it interactive',
    'map-instruction-button-text': 'Interact with the map',
  },
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
